import React from 'react'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  Tooltip,
  Legend,
)

const GraficoEntradaPorMes = ({ indicador }) => {
  const data = {
    labels: indicador.entradas6meses.labels,
    datasets: [
      {
        label: 'Entradas últimos 6 meses',
        data: indicador.entradas6meses.total,
        backgroundColor: '#4caf50',
      },
    ],
  }

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: {
        type: 'logarithmic', // 👈 agora funciona
      },
    },
  }

  return (
    <div style={{ width: '100%', height: '180px' }}>
      <Bar
        key={JSON.stringify(indicador.entradas6meses.total)}
        data={data}
        options={options}
        redraw
      />
    </div>
  )
}

export default GraficoEntradaPorMes
